import { render, staticRenderFns } from "./jiangjie.vue?vue&type=template&id=2c96938a&scoped=true&"
import script from "./jiangjie.vue?vue&type=script&lang=js&"
export * from "./jiangjie.vue?vue&type=script&lang=js&"
import style0 from "./jiangjie.vue?vue&type=style&index=0&id=2c96938a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96938a",
  null
  
)

export default component.exports